/* Winterfeldt – Suchvorschlaege unter dem Suchfeld.

   Leeres Feld: Kategorien aus dem Hauptmenue als Schnell-Links.
   Beim Tippen, von oben nach unten:
   1) passende Hersteller und Kategorien (max. 3), z. B. "zot" ->
      "Zotter · Hersteller · 5 Produkte" -> direkt zur Hersteller-Seite,
   2) bis zu 5 lieferbare Produkte. Reihenfolge: Titel beginnt mit der
      Eingabe, dann Marke oder Produktname beginnt damit, dann alle
      eingegebenen Woerter als Wortanfang im Titel, zuletzt als Teil eines
      zusammengesetzten Wortes ("milch" -> "Vollmilchschokolade").
      Innerhalb gleicher Stufe: Bestseller zuerst.
   3) "Alle Treffer fuer ...".
   Kein Treffer: "Meintest du ...?" (verzeiht 1–2 Tippfehler bei
   Herstellern, Kategorien und Woertern aus den Produktnamen).
   Treffer werden fett markiert.

   Daten: sections/wf-suchindex.liquid (nur lieferbare Produkte mit Preis
   und Bild, Bestseller zuerst; dazu Kategorien + Hersteller). Wird beim
   ersten Antippen des Suchfelds geladen und 30 Minuten im Browser
   zwischengespeichert. Gilt fuer jedes Suchfeld .wf-suche__form
   (Kopfzeile und Suchseite). Pfeiltasten + Enter waehlen, Escape schliesst. */
(function () {
  'use strict';

  var MAX = 5;
  var MAX_ZIELE = 3;
  var CACHE_KEY = 'wf-suchindex-v2';
  var CACHE_TTL = 30 * 60 * 1000;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var indexPromise = null;
  var zaehler = 0;

  /* Gleiche Marke unter zwei Namen: wird zusammengefasst. */
  var MARKEN_ALIAS = { 'winterfeldt': 'Winterfeldt Schokoladen' };

  function norm(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/ß/g, 'ss');
  }

  function kompakt(s) {
    return norm(s).replace(/[^a-z0-9]/g, '');
  }

  function woerterVon(s) {
    return norm(s).split(/[^a-z0-9]+/).filter(Boolean);
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function markenName(v) {
    return MARKEN_ALIAS[norm(v).trim()] || v || '';
  }

  /* ---- Daten ------------------------------------------------------------ */
  function vorbereiten(daten) {
    var list = daten.list;
    var proMarke = {};
    /* Woerter aus den Produktnamen fuer "Meintest du": kompakt -> Original
       (klein, mit Umlauten, damit der Vorschlag richtig geschrieben ist). */
    var vokabel = {};

    list.forEach(function (p, i) {
      var teile = String(p.t).split(' | ');
      p.o = i;
      p.marke = markenName(p.v || (teile.length > 1 ? teile[0] : ''));
      p.name = teile.length > 1 ? teile.slice(1).join(' | ') : p.t;
      p.kt = kompakt(p.t);
      p.kv = kompakt(p.marke);
      p.kn = kompakt(p.name);
      p.w = woerterVon(p.t + ' ' + p.marke);
      var km = kompakt(p.marke);
      proMarke[km] = (proMarke[km] || 0) + 1;
      String(p.t).toLowerCase().split(/[^0-9a-zÀ-ɏ]+/).forEach(function (w) {
        if (w.length < 4 || /^\d+$/.test(w)) return;
        var k = kompakt(w);
        if (!vokabel[k] || w.length < vokabel[k].length) vokabel[k] = w;
      });
    });

    var z = daten.ziele || { kategorien: [], marken: [] };
    var ziele = [];
    (z.kategorien || []).forEach(function (k) {
      ziele.push({ typ: 'Kategorie', n: k.n, u: k.u, w: woerterVon(k.n + ' ' + (k.a || '')), k: [kompakt(k.n), kompakt(k.a)], anzahl: 0 });
    });
    var gesehen = {};
    (z.marken || []).forEach(function (m) {
      var name = markenName(m.n);
      var km = kompakt(name);
      var anzahl = proMarke[km] || 0;
      if (!anzahl || gesehen[km]) return;
      if (MARKEN_ALIAS[norm(m.n).trim()]) return; /* Alias: das Original zaehlt */
      gesehen[km] = true;
      ziele.push({ typ: 'Hersteller', n: name, u: m.u, w: woerterVon(name), k: [km], anzahl: anzahl });
    });

    return { list: list, ziele: ziele, vokabel: vokabel };
  }

  function ladeSeite(n) {
    var url = root + 'collections/all?section_id=wf-suchindex&sort_by=best-selling&page=' + n;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Suchindex ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('script[data-wf-index]');
        var zi = doc.querySelector('script[data-wf-ziele]');
        if (!el) return { pages: 1, list: [], ziele: null };
        return {
          pages: parseInt(el.getAttribute('data-pages'), 10) || 1,
          list: JSON.parse(el.textContent),
          ziele: zi ? JSON.parse(zi.textContent) : null
        };
      });
  }

  function ladeIndex() {
    if (indexPromise) return indexPromise;
    try {
      var c = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.list && Date.now() - c.zeit < CACHE_TTL) {
        indexPromise = Promise.resolve(vorbereiten(c));
        return indexPromise;
      }
    } catch (e) { /* ohne Zwischenspeicher weiter */ }

    indexPromise = ladeSeite(1).then(function (erste) {
      var rest = [];
      for (var i = 2; i <= erste.pages && i <= 20; i++) rest.push(ladeSeite(i));
      return Promise.all(rest).then(function (seiten) {
        var list = erste.list;
        seiten.forEach(function (s) { list = list.concat(s.list); });
        var daten = { zeit: Date.now(), list: list, ziele: erste.ziele };
        try {
          window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(daten));
        } catch (e) { /* Speicher voll oder gesperrt */ }
        return vorbereiten(daten);
      });
    }).catch(function (e) {
      indexPromise = null;
      throw e;
    });
    return indexPromise;
  }

  /* ---- Suchen ----------------------------------------------------------- */
  function alleWoerterPassen(woerter, liste) {
    return woerter.length && woerter.every(function (t) {
      return liste.some(function (w) { return w.indexOf(t) === 0; });
    });
  }

  function sucheZiele(index, q) {
    var kq = kompakt(q);
    var woerter = woerterVon(q);
    if (!kq) return [];
    var t = [];
    index.ziele.forEach(function (z) {
      var r;
      if (z.k.some(function (k) { return k && k.indexOf(kq) === 0; })) r = 0;
      else if (alleWoerterPassen(woerter, z.w)) r = 1;
      else return;
      t.push({ z: z, r: r });
    });
    t.sort(function (a, b) {
      return a.r - b.r || (a.z.typ === b.z.typ ? 0 : a.z.typ === 'Hersteller' ? -1 : 1) || b.z.anzahl - a.z.anzahl;
    });
    /* Gleiche Seite nur einmal (Hausmarke = Hersteller Winterfeldt). */
    var urls = {};
    t = t.filter(function (x) {
      if (urls[x.z.u]) return false;
      urls[x.z.u] = true;
      return true;
    });
    return t.slice(0, MAX_ZIELE).map(function (x) { return x.z; });
  }

  function sucheProdukte(index, q) {
    var kq = kompakt(q);
    if (!kq) return [];
    var woerter = woerterVon(q);
    var treffer = [];
    index.list.forEach(function (p) {
      var rang;
      if (p.kt.indexOf(kq) === 0) rang = 0;
      else if (p.kv.indexOf(kq) === 0 || p.kn.indexOf(kq) === 0) rang = 1;
      else if (alleWoerterPassen(woerter, p.w)) rang = 2;
      else if (woerter.length && woerter.every(function (t) { return t.length >= 3 && p.kt.indexOf(t) !== -1; })) rang = 3;
      else return;
      treffer.push({ p: p, r: rang });
    });
    treffer.sort(function (a, b) { return a.r - b.r || a.p.o - b.p.o; });
    return treffer.slice(0, MAX).map(function (x) { return x.p; });
  }

  /* Tippfehler: Abstand zwischen zwei Woertern (Levenshtein). */
  function abstand(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m || !n) return m || n;
    var vor = [], j;
    for (j = 0; j <= n; j++) vor[j] = j;
    for (var i = 1; i <= m; i++) {
      var akt = [i];
      for (j = 1; j <= n; j++) {
        akt[j] = Math.min(vor[j] + 1, akt[j - 1] + 1, vor[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      vor = akt;
    }
    return vor[n];
  }

  /* Anfang eines Original-Wortes, der kompakt 'laenge' Zeichen lang ist
     ("nougatfüllung", 6 -> "nougat"). */
  function wortAnfang(orig, laenge) {
    if (kompakt(orig).length <= laenge) return orig;
    for (var i = 1; i <= orig.length; i++) {
      if (kompakt(orig.slice(0, i)).length >= laenge) return orig.slice(0, i);
    }
    return orig;
  }

  function meintestDu(index, q) {
    var nq = kompakt(q);
    if (nq.length < 3) return null;
    var grenze = nq.length >= 6 ? 2 : 1;
    var best = null;

    /* Verglichen wird mit dem Anfang (gleich lang und ein Zeichen
       laenger, fuer angefangene oder um einen Buchstaben kuerzere
       Eingaben) und mit dem ganzen Wort. */
    function varianten(k) {
      return [k.slice(0, nq.length + 1), k.slice(0, nq.length), k];
    }

    index.ziele.forEach(function (z) {
      [z.n].concat(z.w.filter(function (w) { return w.length >= 4; })).forEach(function (kand) {
        varianten(kompakt(kand)).forEach(function (v) {
          if (!v) return;
          var d = abstand(nq, v);
          if (d <= grenze && (!best || d < best.d)) best = { d: d, wert: { ziel: z } };
        });
      });
    });

    if (!best || best.d > 0) {
      Object.keys(index.vokabel).forEach(function (k) {
        varianten(k).forEach(function (v) {
          if (!v) return;
          var d = abstand(nq, v);
          if (d <= grenze && (!best || d < best.d)) {
            best = { d: d, wert: { wort: wortAnfang(index.vokabel[k], v.length) } };
          }
        });
      });
    }
    return best ? best.wert : null;
  }

  /* Eingegebene Woerter fett markieren: an Wortanfaengen; steckt ein Wort
     nur mitten in einem zusammengesetzten Wort, dort. */
  function markiere(text, q) {
    var orig = String(text || '');
    var woerter = woerterVon(q);
    if (!woerter.length) return esc(orig);
    var zeichen = [], wohin = [];
    for (var i = 0; i < orig.length; i++) {
      var n = norm(orig[i]);
      for (var j = 0; j < n.length; j++) { zeichen.push(n[j]); wohin.push(i); }
    }
    var ns = zeichen.join('');
    var fett = [];
    function setze(pos, len) {
      for (var k = pos; k < pos + len; k++) fett[wohin[k]] = true;
    }
    woerter.forEach(function (w) {
      var pos = 0, gefunden = false;
      while ((pos = ns.indexOf(w, pos)) !== -1) {
        if (pos === 0 || !/[a-z0-9]/.test(ns[pos - 1])) { setze(pos, w.length); gefunden = true; }
        pos += 1;
      }
      if (!gefunden && w.length >= 3) {
        var mitte = ns.indexOf(w);
        if (mitte !== -1) setze(mitte, w.length);
      }
    });
    var html = '', offen = false;
    for (var x = 0; x < orig.length; x++) {
      if (fett[x] && !offen) { html += '<strong>'; offen = true; }
      if (!fett[x] && offen) { html += '</strong>'; offen = false; }
      html += esc(orig[x]);
    }
    if (offen) html += '</strong>';
    return html;
  }

  /* ---- Anzeige ---------------------------------------------------------- */
  function verbinde(form) {
    var feld = form.querySelector('input[name="q"]');
    if (!feld || form.getAttribute('data-wf-vorschlag') === 'an') return;
    form.setAttribute('data-wf-vorschlag', 'an');

    var id = 'wf-vorschlag-' + (++zaehler);
    var box = document.createElement('div');
    box.className = 'wf-vorschlag';
    box.id = id;
    box.hidden = true;
    box.setAttribute('role', 'listbox');
    box.setAttribute('aria-label', 'Suchvorschläge');
    form.appendChild(box);

    feld.setAttribute('role', 'combobox');
    feld.setAttribute('aria-autocomplete', 'list');
    feld.setAttribute('aria-controls', id);
    feld.setAttribute('aria-expanded', 'false');

    var aktiv = -1;
    var timer = null;
    var lfd = 0;

    function eintraege() { return box.querySelectorAll('a'); }

    function setzeAktiv(i) {
      var items = eintraege();
      aktiv = i;
      for (var k = 0; k < items.length; k++) {
        var an = k === aktiv;
        items[k].classList.toggle('ist-aktiv', an);
        items[k].setAttribute('aria-selected', an ? 'true' : 'false');
      }
      if (aktiv >= 0 && items[aktiv]) feld.setAttribute('aria-activedescendant', items[aktiv].id);
      else feld.removeAttribute('aria-activedescendant');
    }

    function schliessen() {
      box.hidden = true;
      feld.setAttribute('aria-expanded', 'false');
      setzeAktiv(-1);
    }

    function oeffnen(html) {
      box.innerHTML = html;
      box.hidden = false;
      feld.setAttribute('aria-expanded', 'true');
      setzeAktiv(-1);
    }

    function suchUrl(q) {
      return root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    }

    function zielZeile(z, q, i) {
      var info = z.typ + (z.anzahl ? ' · ' + z.anzahl + (z.anzahl === 1 ? ' Produkt' : ' Produkte') : '');
      return '<a class="wf-vorschlag__ziel" id="' + id + '-z' + i + '" role="option" aria-selected="false" href="' + esc(z.u) + '">' +
        '<span class="wf-vorschlag__ziel-text">' +
          '<span class="wf-vorschlag__ziel-name">' + markiere(z.n, q) + '</span>' +
          '<span class="wf-vorschlag__ziel-info">' + esc(info) + '</span>' +
        '</span>' +
        '<span class="wf-vorschlag__pfeil" aria-hidden="true">&rarr;</span>' +
      '</a>';
    }

    function produktZeile(p, q, i) {
      return '<a class="wf-vorschlag__item" id="' + id + '-' + i + '" role="option" aria-selected="false" href="' + esc(p.u) + '">' +
        '<img class="wf-vorschlag__bild" src="' + esc(p.i) + '" alt="" width="52" height="52" loading="lazy">' +
        '<span class="wf-vorschlag__text">' +
          (p.marke ? '<span class="wf-vorschlag__marke">' + markiere(p.marke, q) + '</span>' : '') +
          '<span class="wf-vorschlag__name">' + markiere(p.name, q) + '</span>' +
        '</span>' +
        '<span class="wf-vorschlag__preis">' + esc(p.p) + '</span>' +
      '</a>';
    }

    function zeigeLeer() {
      ladeIndex().then(function (index) {
        if (feld.value.trim() || document.activeElement !== feld) return;
        var kat = index.ziele.filter(function (z) { return z.typ === 'Kategorie'; });
        if (!kat.length) return;
        oeffnen('<div class="wf-vorschlag__leer">' +
          '<span class="wf-vorschlag__kopf">Beliebte Kategorien</span>' +
          '<div class="wf-vorschlag__chips">' +
            kat.map(function (z, i) {
              return '<a class="wf-vorschlag__chip" id="' + id + '-k' + i + '" role="option" aria-selected="false" href="' + esc(z.u) + '">' + esc(z.n) + '</a>';
            }).join('') +
          '</div></div>');
      }).catch(function () {});
    }

    function zeigen(q) {
      var nr = ++lfd;
      ladeIndex().then(function (index) {
        if (nr !== lfd || feld.value.trim() !== q) return;
        var ziele = sucheZiele(index, q);
        var produkte = sucheProdukte(index, q);
        var html = '';

        html += ziele.map(function (z, i) { return zielZeile(z, q, i); }).join('');
        html += produkte.map(function (p, i) { return produktZeile(p, q, i); }).join('');

        if (!ziele.length && !produkte.length) {
          var vorschlag = meintestDu(index, q);
          if (vorschlag && vorschlag.ziel) {
            html += '<a class="wf-vorschlag__meintest" id="' + id + '-m" role="option" aria-selected="false" href="' + esc(vorschlag.ziel.u) + '">' +
              '<span>Meintest du <strong>' + esc(vorschlag.ziel.n) + '</strong>?</span>' +
              '<span class="wf-vorschlag__pfeil" aria-hidden="true">&rarr;</span></a>';
          } else if (vorschlag && vorschlag.wort) {
            html += '<a class="wf-vorschlag__meintest" id="' + id + '-m" role="option" aria-selected="false" href="' + esc(suchUrl(vorschlag.wort)) + '" data-wf-wort="' + esc(vorschlag.wort) + '">' +
              '<span>Meintest du <strong>„' + esc(vorschlag.wort) + '“</strong>?</span>' +
              '<span class="wf-vorschlag__pfeil" aria-hidden="true">&rarr;</span></a>';
          } else {
            html += '<p class="wf-vorschlag__nichts">Keine passenden Produkte gefunden.</p>';
          }
        }

        html += '<a class="wf-vorschlag__alle" id="' + id + '-alle" role="option" aria-selected="false" href="' + esc(suchUrl(q)) + '">' +
          '<span>' + (produkte.length ? 'Alle Treffer für „' + esc(q) + '“' : 'Nach „' + esc(q) + '“ suchen') + '</span>' +
          '<span aria-hidden="true">&rarr;</span></a>';
        oeffnen(html);
      }).catch(function () {
        schliessen();
      });
    }

    /* "Meintest du <Wort>?" uebernimmt das Wort ins Feld statt zu springen. */
    box.addEventListener('click', function (e) {
      var a = e.target.closest('[data-wf-wort]');
      if (!a) return;
      e.preventDefault();
      feld.value = a.getAttribute('data-wf-wort');
      feld.focus();
      zeigen(feld.value.trim());
    });

    feld.addEventListener('input', function () {
      clearTimeout(timer);
      var q = feld.value.trim();
      if (!q) { zeigeLeer(); return; }
      timer = setTimeout(function () { zeigen(q); }, 60);
    });

    feld.addEventListener('focus', function () {
      ladeIndex().catch(function () {});
      var q = feld.value.trim();
      if (q) zeigen(q);
      else zeigeLeer();
    });

    feld.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      var n = eintraege().length;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setzeAktiv(aktiv + 1 >= n ? 0 : aktiv + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setzeAktiv(aktiv - 1 < 0 ? n - 1 : aktiv - 1);
      } else if (e.key === 'Enter' && aktiv >= 0) {
        e.preventDefault();
        eintraege()[aktiv].click();
      } else if (e.key === 'Escape') {
        schliessen();
      }
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) schliessen();
    });
  }

  function start() {
    var formen = document.querySelectorAll('.wf-suche__form');
    for (var i = 0; i < formen.length; i++) verbinde(formen[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
